import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ThemeService } from './core/services/theme.service';
import { WebPushService } from './core/services/web-push.service';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [
    CommonModule,
    RouterModule,
  ]
})
export class AppComponent {
  title = 'i4option-dashboard';
    private push = inject(WebPushService);
  constructor(private themeService: ThemeService) {}
}